<template>
  <van-popup
      v-model:show="showPopup"
      position="bottom"
      :style="{ width: '100%' }"
      round
      :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }"
      :close-on-click-overlay="true"
      @click-overlay="closePopup"
  >
    <div class="payment-card" @click.stop>
      <div class="card-content">
        <!-- 标题区域 -->
        <div class="header">
          <van-icon name="money" color="#ff976a" size="20" />
          <h3 class="card-title">收款确认</h3>
        </div>

        <!-- 金额信息 -->
        <p class="amount-label">待收款金额</p>
<!--        <p class="amount">¥{{ paymentInfo.amount.toFixed(2) }}</p>-->

        <!-- 附加信息 -->
<!--        <p class="additional-info" v-if="paymentInfo.description">-->
<!--          {{ paymentInfo.description }}-->
<!--        </p>-->

        <!-- 状态提示 -->
        <p class="message" v-if="message">{{ message }}</p>

        <!-- 按钮区域 -->
        <div class="button-group">
          <button class="cancel-button" @click="closePopup">
            取消
          </button>
          <button
              class="confirm-button"
              @click="requestPaymentConfirmation"
              :disabled="isLoading"
          >
            <van-loading
                v-if="isLoading"
                color="#fff"
                size="16"
                class="loading-icon"
            />
            {{ isLoading ? '处理中...' : '确认收款' }}
          </button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon, Loading } from "vant";
import { mapGetters } from "vuex";
import wx from "weixin-js-sdk";
export default {
  name: 'WechatPaymentPopup',
  components: {
    VanPopup: Popup,
    VanIcon: Icon,
    VanLoading: Loading
  },
  data() {
    return {
      showPopup: false,
      isLoading: false,
      message: '',
      autoCloseTimer: null,
      paymentInfo: {
        mchId: '',
        appId: '',
        package: ''
      }
    };
  },
  computed: {
    ...mapGetters(["userInfo", "live","appId"])
  },
  mounted() {
    // 初始化微信JS-SDK（建议在全局初始化，这里做检查）
    if (typeof wx === 'undefined') {
      console.warn('微信JS-SDK未加载');
    }
  },
  methods: {
    /**
     * 初始化微信JS-SDK配置
     */
    async initWechatJSAPI() {
      try {
        const currentUrl = window.location.href.split('#')[0];
        const { data } = await this.$http.get(`/wechat/config/${this.appId}`,{
          params: { url: currentUrl }
        });

        wx.config({
          debug: process.env.NODE_ENV === 'development',
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList
        });

        return new Promise((resolve, reject) => {
          wx.ready(() => {
            console.log('微信JS-SDK初始化成功');
            resolve(true);
          });

          wx.error((err) => {
            console.error('微信JS-SDK初始化失败:', err);
            this.message = '微信环境初始化失败，请刷新页面重试';
            reject(err);
          });
        });
      } catch (error) {
        console.error('获取微信配置失败:', error);
        this.message = '系统错误，请稍后再试';
        return Promise.reject(error);
      }
    },

    /**
     * 调起微信收款确认
     */
    async requestPaymentConfirmation() {
      this.isLoading = true;
      this.message = '';

      try {
        // 检查是否在微信环境
        if (typeof wx === 'undefined') {
          this.message = '请在微信客户端中操作';
          this.isLoading = false;
          return;
        }

        // 初始化JSAPI
        await this.initWechatJSAPI();
        // 检查API可用性
        wx.checkJsApi({
          jsApiList: ['requestMerchantTransfer'],
          success: (res) => {
            if (res.checkResult['requestMerchantTransfer']) {
              // 调用微信转账接口
              WeixinJSBridge.invoke('requestMerchantTransfer', {
                    mchId: this.paymentInfo.mchId,
                    appId: this.paymentInfo.appId,
                    package: this.paymentInfo.package,
                  },
                  (res) => {
                    if (res.err_msg === 'requestMerchantTransfer:ok') {
                      console.log('转账请求成功:', res);
                      this.message = '转账请求已发送';
                      this.$emit('confirmSuccess', res);

                      // 3秒后自动关闭
                      setTimeout(() => {
                        this.closePopup();
                      }, 3000);
                    } else {
                      console.error('转账请求失败:', res);
                      this.message = res.err_msg || '转账请求失败，请重试';
                      this.$emit('confirmFail', res);
                    }
                    this.isLoading = false;
                  }
              );
            } else {
              this.message = '您的微信版本过低，请更新至最新版本';
              this.isLoading = false;
            }
          },
          fail: (err) => {
            console.error('检查API失败:', err);
            this.message = '系统错误，请稍后再试';
            this.isLoading = false;
          }
        });

      } catch (error) {
        console.error('操作失败:', error);
        this.message = '操作失败，请稍后再试';
        this.isLoading = false;
      }
    },

    /**
     * 打开弹出框
     * @param {Object} paymentInfo - 收款信息
     */
    openPopup(paymentInfo) {
      this.paymentInfo = {
        mchId: '',
        appId: '',
        package: '',
        ...paymentInfo
      };
      this.showPopup = true;
      this.message = '';
      // this.startAutoClose();
    },

    /**
     * 关闭弹出框
     */
    closePopup() {
      this.showPopup = false;
      this.isLoading = false;
      this.clearAutoCloseTimer();
    },

    /**
     * 启动自动关闭计时器
     */
    startAutoClose() {
      this.clearAutoCloseTimer();
      this.autoCloseTimer = setTimeout(() => {
        this.closePopup();
        console.log('自动关闭收款弹窗');
      }, 30000); // 30秒自动关闭
    },

    /**
     * 清除自动关闭计时器
     */
    clearAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    }
  },
  beforeUnmount() {
    this.clearAutoCloseTimer();
  }
};
</script>

<style lang="less" scoped>
.payment-card {
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 20px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);

  .card-content {
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      .card-title {
        font-size: 18px;
        color: #000;
        font-weight: 600;
        margin-left: 8px;
      }
    }

    .amount-label {
      font-size: 14px;
      color: #666;
      text-align: center;
      margin-bottom: 8px;
    }

    .amount {
      font-size: 28px;
      color: #e63946;
      font-weight: bold;
      text-align: center;
      margin-bottom: 16px;
    }

    .additional-info {
      font-size: 14px;
      color: #666;
      text-align: center;
      padding: 10px;
      background-color: #f5f5f5;
      border-radius: 8px;
      margin-bottom: 20px;
    }

    .message {
      color: #f53f3f;
      font-size: 14px;
      text-align: center;
      margin-bottom: 16px;
      min-height: 20px;
    }

    .button-group {
      display: flex;
      gap: 12px;
      margin-top: 16px;

      .cancel-button, .confirm-button {
        flex: 1;
        padding: 12px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        border: none;
      }

      .cancel-button {
        background-color: #f5f5f5;
        color: #333;

        &:hover {
          background-color: #eeeeee;
        }
      }

      .confirm-button {
        background-color: #28c76f;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: #25a362;
        }

        &:disabled {
          background-color: #97edc0;
          cursor: not-allowed;
        }
      }

      .loading-icon {
        margin-right: 8px;
      }
    }
  }
}
</style>
